// Real Istanbul Tours - static content & i18n keys

export const brand = {
  name: "Real Istanbul Tours",
  logo: "Real Istanbul",
};

export const LANGS = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
];

export const MENU = [
  { key: "all-tours", href: "/tours", label: "All Tours" },
  { key: "small-group", href: "/tours/small-group", label: "Small Group Tours" },
  { key: "private", href: "/tours/private", label: "Private Tours" },
  { key: "cooking", href: "/tours/cooking", label: "Cooking Classes" },
  { key: "workshops", href: "/tours/workshops", label: "Workshops" },
  { key: "day-trips", href: "/tours/day-trips", label: "Day Trips from Istanbul" },
  { key: "about", href: "/about", label: "About" },
  { key: "blog", href: "/blog", label: "Blog" },
  { key: "faq", href: "/faq", label: "FAQ" },
  { key: "contact", href: "/contact", label: "Contact" },
];

export const CATEGORY_META = {
  "small-group": {
    label: "Small Group Tours",
    tagline: "Max 12 guests · daily departures",
    title: "Small-group Istanbul tours with a local licensed guide.",
    description:
      "Walk the Old City, cross the Bosphorus, meet Istanbul with a small group and a guide who lives here. Free cancellation up to 24 hours before.",
    image: "https://images.unsplash.com/photo-1527838832700-5059252407fa",
  },
  private: {
    label: "Private Tours",
    tagline: "Your date, your time, your route",
    title: "Private Istanbul tours, designed around your day.",
    description:
      "A private guide, a private car, and a route we build around you. Anything on our public schedule can run privately, and much more.",
    image: "https://images.unsplash.com/photo-1636537511494-c3e558e0702b",
  },
  cooking: {
    label: "Cooking Classes",
    tagline: "Hands-on, in a real kitchen",
    title: "Turkish cooking classes with local home chefs.",
    description:
      "Manti, meze, köfte, baklava. Cook a full Turkish meal from scratch and sit down to eat what you made, all in a real Istanbul kitchen.",
    image: "https://images.unsplash.com/photo-1690063860120-3521cead6c1c",
  },
  workshops: {
    label: "Workshops",
    tagline: "Learn a craft from a master",
    title: "Turkish craft workshops in Istanbul.",
    description:
      "Ebru marbling, calligraphy, ceramics. Small classes with masters who have spent decades earning the right to teach these arts.",
    image: "https://images.unsplash.com/photo-1663213774378-b83b5f0bceb7",
  },
  "day-trips": {
    label: "Day Trips from Istanbul",
    tagline: "Beyond the city, with a guide",
    title: "Cappadocia and Ephesus, from Istanbul.",
    description:
      "Fairy chimneys and hot air balloons in Cappadocia, ancient ruins in Ephesus. Full guided day trips and multi-day packages departing from Istanbul.",
    image: "https://images.unsplash.com/photo-1600714480856-dc99b28892eb",
  },
};

export const heroStats = [
  { value: "2014", label: "Operating since" },
  { value: "60,000+", label: "Guests hosted" },
  { value: "2023 · 2024 · 2025", label: "Top 10 Tours in Europe" },
];

export const reviewPlatforms = [
  { name: "Viator", rating: "4.9", count: "1,000+" },
  { name: "Tripadvisor", rating: "4.91", count: "711+" },
  { name: "Google", rating: "4.9", count: "876+" },
];

export const aboutStats = [
  { value: "11", label: "Years of Istanbul tours" },
  { value: "10,000+", label: "Happy Guests" },
  { value: "4.95★", label: "From 1,000+ Reviews" },
];

export const itinerary = [
  {
    side: "European side",
    step: 1,
    title: "Sultanahmet & the Blue Mosque",
    description:
      "You meet at the Hippodrome. Your guide walks you into the Sultan Ahmed Mosque, past the Egyptian obelisk and the German Fountain, with the stories the crowds walk right past.",
    image: "https://images.unsplash.com/photo-1527838832700-5059252407fa",
    highlights: "Blue Mosque · Hippodrome · Serpent Column · Byzantine origins",
  },
  {
    side: "European side",
    step: 2,
    title: "Hagia Sophia & Topkapı Palace",
    description:
      "Skip the line into Hagia Sophia and its shimmering gold mosaics, then across the courtyard into Topkapı, four centuries of sultans, their harem and their treasury.",
    image: "https://images.unsplash.com/photo-1663213774378-b83b5f0bceb7",
    highlights: "Byzantine mosaics · Imperial gate · Harem quarters · Ottoman jewels",
  },
  {
    side: "The crossing",
    step: 3,
    title: "The Bosphorus ferry",
    description:
      "Cross from Europe to Asia by public ferry, twenty minutes on deck for sea air, seagulls trailing the boat and the city's stories from the water.",
    image: "https://images.unsplash.com/photo-1636537511494-c3e558e0702b",
    highlights: "Both continents · Maiden's Tower · Dolmabahçe from the water",
  },
  {
    side: "Asian side",
    step: 4,
    title: "Kadıköy & the local markets",
    description:
      "You are on the Asian side now, where Istanbullus actually live. Fish counters, cheese shops, olive stalls and small lokantas where lunch is waiting.",
    image: "https://images.unsplash.com/photo-1629212093584-6e1769fb1598",
    highlights: "Kadıköy market · Moda backstreets · Local lunch · Baklava to finish",
  },
];

export const testimonials = [
  { title: "Perfect for our first day in Istanbul", quote: "Perfect for our first day in Istanbul. Everything we wanted to see, without a single queue. Highly recommend.", author: "T.H.", source: "via Tripadvisor" },
  { title: "You will not need another guide", quote: "Incredible value. Our guide covered a thousand years of Istanbul between two mosques, and lunch was the best meal of our trip.", author: "G.C.", source: "via Tripadvisor" },
  { title: "As a history buff, this was spot on", quote: "As someone who reads a lot about Byzantium, this tour was spot on. Our guide wove real research into every stop, effortlessly.", author: "L.W.", source: "via Tripadvisor" },
  { title: "Off the beaten path, where locals go", quote: "Our guide knew the shopkeepers by name and took us to places you'd never find in a guidebook. Kadıköy stole the show.", author: "A.Y.", source: "via Tripadvisor" },
  { title: "The ferry crossing was the perfect blend", quote: "Crossing the Bosphorus was the perfect blend of stunning views, real history, and a break in the middle of a busy day.", author: "C.B.", source: "via Tripadvisor" },
  { title: "One of the highlights of our trip", quote: "A standout guide, warm, funny and endlessly knowledgeable. One of the highlights of our whole two weeks in Turkey.", author: "V.W.", source: "via Tripadvisor" },
  { title: "Small, intimate, and rich in local culture", quote: "Small, intimate group and a guide who clearly loves this city. Rich in local culture from the first minute.", author: "V.U.", source: "via Tripadvisor" },
  { title: "We saw everything, without the crowds", quote: "We saw every major site with skip-the-line entry, then finished on the Asian side where the real Istanbul lives.", author: "Y.K.", source: "via Tripadvisor" },
];

export const faqs = [
  { q: "Is a guided Istanbul tour worth it?", a: "Yes. Istanbul rewards context, and a good guide replaces hours of queuing with skip-the-line entries, layered history and neighborhoods you would not find alone." },
  { q: "Do I really need a guide, or can I explore on my own?", a: "You can, but Sultanahmet is packed and the ticket queues at Hagia Sophia and Topkapı are long. A licensed guide adds skip-the-line access, and the difference between reading a plaque and hearing 1,500 years of stories." },
  { q: "Will a tour just take me to tourist traps?", a: "Real Istanbul Tours pairs iconic sights with hidden local favorites: the small workshops off the Grand Bazaar, the ferry route your hotel will not tell you about, and lunch in Kadıköy." },
  { q: "How much does an Istanbul tour cost?", a: "Small-group tours in Istanbul typically cost €55-€185 per person. Our tours are €40-€125, and private tours start from €420 for a full day." },
  { q: "What is included?", a: "Licensed local guide, skip-the-line entries where applicable, ferries or transport as noted, and tastings or meals as listed in the itinerary." },
  { q: "Which side of Istanbul is better to visit?", a: "Both, and a good day covers both. The European side has the famous sights, the Asian side is where locals live and eat. Twenty minutes apart by ferry." },
  { q: "How long does an Istanbul tour last?", a: "Our tours range from 2 hours (workshops) to 8 hours (full-day private). Most guests find a 5-7 hour tour is the sweet spot for their first day in the city." },
  { q: "Is Real Istanbul Tours legit?", a: "Yes. Real Istanbul Tours has run small-group tours since 2014, guiding more than 60,000 guests. Rated 4.95 out of 5 across 7,030+ reviews on Tripadvisor, Viator, GetYourGuide, Google and Airbnb." },
  { q: "How do I pay?", a: "Submit the booking form and we will reply within a day with a secure payment link (Stripe or PayPal). Free cancellation up to 24 hours before your tour." },
];

export const pressLogos = [
  "Condé Nast Traveler",
  "Lonely Planet",
  "National Geographic",
  "The Guardian",
  "Fodor's Travel",
];

export const blogPosts = [
  {
    slug: "free-self-guided-istanbul-walk",
    label: "Istanbul",
    title: "Free Self-Guided Istanbul Walk: 3 Routes, 14 Stops",
    excerpt: "Three walking routes across Sultanahmet, Kadıköy and Karaköy with fourteen carefully chosen stops. Print it, save it, walk it.",
    image: "https://images.unsplash.com/photo-1629212093584-6e1769fb1598",
    date: "March 12, 2025",
    read: "9 min read",
    body: "Istanbul rewards walking. This is our free self-guided route through three neighbourhoods, with fourteen stops we would take our own family to. Start in Sultanahmet, cross to Karaköy, then ferry to Kadıköy and finish in Moda. If you're short on time, do just one section. If you have all day, do all three, they connect naturally by ferry and short walks.",
  },
  {
    slug: "what-to-buy-in-the-grand-bazaar",
    label: "Istanbul",
    title: "What to Buy in the Grand Bazaar: A Real Guide",
    excerpt: "Beyond souvenir keychains. Ceramics from Kütahya, real külah cükari, and the small workshops most tourists walk right past.",
    image: "https://images.unsplash.com/photo-1629212191994-76eccd4aeb17",
    date: "February 20, 2025",
    read: "7 min read",
    body: "The Grand Bazaar has 4,000 shops. Ninety percent sell the same tourist items. Ten percent are family workshops running for four generations. This guide is about the ten percent. We list five categories worth spending money on, five to avoid, and how to actually bargain without being rude or overpaying.",
  },
  {
    slug: "hagia-sophia-vs-blue-mosque",
    label: "Istanbul",
    title: "Hagia Sophia vs Blue Mosque: What is the Difference?",
    excerpt: "They face each other across a park. They look similar. They are not, and understanding why is the shortest path into 1,500 years of Istanbul.",
    image: "https://images.unsplash.com/photo-1621164870333-7931835f05de",
    date: "January 30, 2025",
    read: "8 min read",
    body: "Hagia Sophia was built in 537. The Blue Mosque was built in 1616. That's more than a thousand years between them, and every detail of the architecture reflects that gap. In this article we break down five differences you can spot from the outside, and five you have to go inside to see.",
  },
  {
    slug: "turkish-breakfast-guide",
    label: "Food",
    title: "The Turkish Breakfast Guide: What Everything Means",
    excerpt: "Menemen, kaymak, sucuk, simit, and why breakfast in Turkey is a two-hour affair.",
    image: "https://images.unsplash.com/photo-1690063860120-3521cead6c1c",
    date: "January 10, 2025",
    read: "6 min read",
    body: "Turkish breakfast is a table covered end to end with small plates. This guide walks you through every dish you might see, in the order you should eat it, with the Turkish words to order more.",
  },
  {
    slug: "bosphorus-ferry-guide",
    label: "Istanbul",
    title: "How to Ride the Bosphorus Ferry Like a Local",
    excerpt: "The public ferry from Eminonü to Kadıköy costs less than a coffee and is the most beautiful commute in Europe. Here is how to do it right.",
    image: "https://images.unsplash.com/photo-1636537511494-c3e558e0702b",
    date: "December 18, 2024",
    read: "5 min read",
    body: "Skip the expensive tourist cruises. The public Istanbul city ferry costs 27 lira and takes you between two continents in twenty minutes. This guide covers which pier, which side of the boat to sit on, and where to eat lunch when you get there.",
  },
  {
    slug: "kadikoy-food-streets",
    label: "Food",
    title: "Kadıköy's Food Streets: A First-Timer's Guide",
    excerpt: "The Asian side is where Istanbullus actually eat. Start here.",
    image: "https://images.unsplash.com/photo-1629212093584-6e1769fb1598",
    date: "November 24, 2024",
    read: "7 min read",
    body: "Cross the Bosphorus to Kadıköy and the city changes. Fewer tourists, more locals, and the food scene most visitors never reach. This guide covers six streets, twelve stops, and the order to do them in.",
  },
];

export const guideKeywords = [
  "licensed local guide",
  "ferry crossing",
  "small group",
  "skip the line",
  "hidden local spots",
  "great value",
  "come curious",
];

export const heroImage = "https://images.unsplash.com/photo-1589561454226-796a8aa89b05";
export const guideImage = "https://images.unsplash.com/photo-1600714480856-dc99b28892eb";
export const tableImage = "https://images.unsplash.com/photo-1690063860120-3521cead6c1c";
export const featuredYouTube = {
  title: "Kara and Nate on the Two Continents Tour.",
  desc: "Travel YouTubers Kara and Nate filmed their day in Istanbul: Hagia Sophia, the Grand Bazaar, the Bosphorus ferry and lunch in Kadıköy.",
  thumbnail: "https://i.ytimg.com/vi/oQGkzsTGMPg/maxresdefault.jpg",
  videoId: "oQGkzsTGMPg",
  channel: "Kara and Nate · Travel YouTubers",
};

// UI strings that will be auto-translated per language
export const UI_STRINGS = {
  book_a_tour: "Book a tour",
  book_now: "Book now",
  learn_more: "Learn more",
  see_itinerary: "See itinerary",
  choose_your_tour: "Choose your tour",
  read_reviews: "Read 7,030+ reviews",
  daily_departures: "DAILY DEPARTURES · MAX 12 GUESTS",
  hero_title: "The Istanbul tour that feels like a day with a local friend.",
  hero_sub: "From skip-the-line at Hagia Sophia to hidden neighbourhoods across two continents.",
  about_eyebrow: "About Real Istanbul Tours",
  about_title: "Small-group Istanbul tours, since 2014.",
  tours_eyebrow: "Perfect Tours for Your First Visit to Istanbul",
  tours_title: "Four Unforgettable Ways to Experience Istanbul.",
  itinerary_eyebrow: "What you'll see",
  itinerary_title: "Old City in the morning, Kadıköy for lunch.",
  guides_eyebrow: "Our guides",
  guides_title: "People who actually live here.",
  stops_eyebrow: "Our stops",
  stops_title: "Real places, chosen over years.",
  reviews_eyebrow: "What guests mention again and again",
  reviews_title: "A summary based on 7,030+ verified guest reviews.",
  featured_eyebrow: "Featured on YouTube",
  press_eyebrow: "Real Istanbul Tours is featured in",
  faq_eyebrow: "FAQ",
  faq_title: "Everything you were about to ask.",
  cta_title: "Come curious. We'll handle the rest.",
  cta_sub: "Four tours, one city, endless experiences. Not sure which one to choose? Browse all our Istanbul tours and find the perfect match for you.",
  free_cancellation: "Free cancellation before 24H",
  instant_confirmation: "Instant confirmation",
  no_booking_fees: "Book direct, no booking fees",
  small_groups_max: "Small groups, max 12",
  footer_tagline: "Small-group tours in Istanbul since 2014. Discover the city with licensed local guides, uncover local neighbourhoods, and experience Istanbul like a local. 4.9★ from 1,000+ verified guest reviews.",
  subscribe: "Subscribe",
  contact_title: "Get in touch.",
  contact_sub: "Booking questions, custom itineraries or just saying hello. We reply within a day.",
  full_name: "Full name",
  email: "Email",
  phone: "Phone (optional)",
  subject: "Subject",
  message: "Message",
  send_message: "Send message",
  book_this_tour: "Book this tour",
  tour_date: "Tour date",
  guests: "Number of guests",
  special_requests: "Special requests (optional)",
  submit_booking: "Submit booking request",
  blog_title: "Stories from Istanbul.",
  blog_sub: "Guides, food deep-dives and neighbourhood essays from our team.",
  read_article: "Read article",
};
